const PALETTE = {
    white: '#FFF',
    black: '#1A1A1A',
    trueBlack: '#000',
    transparent: 'transparent',
    greyscale5: '#F2F2F2',
    greyscale20: '#CCCCCC',
    greyscale40: '#999999',
    greyscale60: '#666666',
    greyscale70: '#4D4D4D',
    greyscale80: '#333', // not from ODS
    greyscale85: '#262626', // not form ODS
    cxpGreyscale90: '#404040', // not form ODS
    systemLightGrey: '#E8E8E8',
    systemMidGrey: '#D1D1D1',
    systemMainYellow: '#FCAF17',
    SystemTaupe: '#C1B28F',
    systemDarkTaupe: '#7B725C',
    systemWarningYellow: '#FFD440',
    systemLightYellow: '#FEF6DC',
    systemDarkYellow: '#8A600D',
    systemMainGreen: '#39B54A',
    systemGreen: '#118847',
    systemLightGreen: '#E5F0E9',
    systemLimeGreen: '#D1EFD4',
    systemDarkLime: '#5F8129',
    systemLightLime: '#DDEDC7',
    serviceOntarioGreen: '#006c40',
    systemDarkGreen: '#2B8737',
    systemLightTeal: '#CFEDED',
    systemDarkTeal: '#367A76',
    systemLightOrange: '#FEE1D9',
    systemDarkOrange: '#C64A1C',
    systemLightRed: '#FFE0E2',
    systemRed: '#CD0000',
    systemRedLight: '#FCEFF0',
    systemLightMagenta: '#FEDFF0',
    systemDarkMagenta: '#C00264',
    systemMidRed: '#6B0000',
    systemDarkRed: '#D81A21',
    systemLightSky: '#C5EEFA',
    systemLightBlue: '#DBE9F5',
    systemBlue: '#0066CC',
    systemSecondaryLightBlue: '#C2E0FF',
    systemSecondaryLightestBlue: '#E0F0FF',
    systemMidBlue: '#00478F',
    systemLinkActiveBlue: '#002142',
    systemDarkBlue: '#0369ac',
    systemFocusBlue: '#009ADB',
    systemInformationBlue: '#E2F0F4',
    systemDarkSky: '#1080A6',
    systemPurple: '#551A8B',
    systemLightPurple: '#F1E3F2',
    systemDarkPurple: '#92278F',
    systemMainGold: '#CBA52E',
    systemDarkGold: '#86743D',
};

// Semantic colors
export default {
    background: PALETTE.white,
    baseLink: PALETTE.systemBlue,
    baseLinkHover: PALETTE.systemMidBlue,
    baseLinkActive: PALETTE.systemDarkBlue,
    baseLinkVisited: PALETTE.systemPurple,
    btnPrimaryBG: PALETTE.systemBlue,
    btnPrimaryHover: PALETTE.systemMidBlue,
    btnPrimaryActive: PALETTE.systemDarkBlue,
    btnSecondaryBG: PALETTE.white,
    btnSecondaryHover: PALETTE.systemSecondaryLightestBlue,
    btnSecondaryActive: PALETTE.systemSecondaryLightBlue,
    btnTertiaryBG: PALETTE.transparent,
    btnTertiaryHover: PALETTE.systemLightGrey,
    btnTertiaryActive: PALETTE.systemMidGrey,
    darkBtnBG: PALETTE.black,
    darkBtnHover: PALETTE.greyscale70,
    darkBtnActive: PALETTE.greyscale60,
    focusBlue: PALETTE.systemFocusBlue,
    calloutErrorBG: PALETTE.systemRedLight,
    calloutErrorBorder: PALETTE.systemRed,
    calloutErrorLink: PALETTE.systemRed,
    calloutErrorLinkHover: PALETTE.systemMidRed,
    calloutErrorLinkActive: PALETTE.systemDarkRed,
    calloutInformationBG: PALETTE.systemInformationBlue,
    calloutInformationBorder: PALETTE.systemDarkSky,
    calloutSuccessBG: PALETTE.systemLightGreen,
    calloutSuccessBorder: PALETTE.systemGreen,
    calloutWarningBG: PALETTE.systemLightYellow,
    calloutWarningBorder: PALETTE.systemMainYellow,
    footerBG: PALETTE.black,
    footerSectionTopBG: PALETTE.greyscale85,
    footerSectionTopBeforeBG: PALETTE.greyscale80,
    footerSocialMediaLinkHover: PALETTE.trueBlack,
    hintTextGrey: PALETTE.greyscale60,
    modalBorder: PALETTE.greyscale20,
    skipLinkBG: PALETTE.systemMainYellow,
    subHeaderBG: PALETTE.serviceOntarioGreen,
    successLight: PALETTE.systemLightGreen,
    tagBG: PALETTE.systemDarkLime,

    // Color palette should only be used when there's no appropriate "semantic" color
    palette: PALETTE,
};
